<template>
  <div class="w-full md:w-5/6">
    <div class="overflow-scroll overflow-x-hidden h-80 md:h-56 pb-32 md:pb-18 relative">
      <Tag @change-page="changePage" v-for="page in pages" v-bind:key="page.id" :page="page"/>
    </div>
  </div>
</template>

<script>
import Tag from "@/components/scheduler/TagSelector/partials/Tag";

export default {
  name: "TagSelector",

  components: {
    Tag,
  },

  props: {
    pages:{
      type:Array,
      require:true
    },
  },

  methods: {
    changePage(payload) {
      this.$emit('change-page', payload)
    },
  },
};
</script>